import { locationActions } from '@common/state/location/actions'
import { getLocationState } from '@common/state/selectors'
import { AppState } from 'app-store'
import { LmiProBuyFormData } from '@lmipro/state/buy-form/state'
import { lmiproCheckoutActions } from '@lmipro/state/checkout/actions'
import { getContentData, getLabelContent, getUserState, getCheckoutState } from '@lmipro/state/selectors'
import { COUNTRIES, SC_SITE } from '@common/constants'
import { lmiproBuyFormActions } from '@lmipro/state/buy-form/actions'
import { getContentLanguage } from '@lmipro/utils/language-helpers'
import { LmiProBillingFormInfoState } from './state'

export const mapLmiProBillingFormInfoState = (state: AppState): LmiProBillingFormInfoState => {
    const {
        billingInformation,
        useAccountInfo,
        firstName,
        lastName,
        address,
        country,
        city,
        state: addressState,
        pleaseSelect,
        postalCode,
        phone,
        taxBusiness,
        taxIndividual,
        taxNumber,
        gSTDisclaimer,
        vATDisclaimer,
        gSTOption,
        vATOption,
        companyName,
        optional,
        taxCodeGST,
        taxCodeVAT,
        errorInvalidTaxNumber,
    } = getLabelContent(state)
    const location = getLocationState(state)

    const {
        existingBillingInformation,
        loggedIn: { isUserLoggedIn },
    } = getUserState(state)

    const { taxType } = getCheckoutState(state)

    const { DefaultCountry: contentDefaultCountry } = getContentData(state)
    const defaultCountry = contentDefaultCountry || COUNTRIES.US
    const language = getContentLanguage()

    return {
        content: {
            billingInformation,
            useAccountInfo,
            firstName,
            lastName,
            address,
            country,
            city,
            state: addressState,
            pleaseSelect,
            postalCode,
            phone,
            taxBusiness,
            taxIndividual,
            taxNumber,
            gSTDisclaimer,
            vATDisclaimer,
            gSTOption,
            vATOption,
            companyName,
            optional,
            taxCodeGST,
            taxCodeVAT,
            errorInvalidTaxNumber,
        },
        location,
        isUserLoggedIn,
        existingBillingInformation,
        defaultCountry,
        taxType,
        language,
    }
}

export const mapLmiProBillingFormInfoActions = {
    getCountries: () => locationActions.getCountries(SC_SITE.LOGMEIN),
    calculatePrice: (values: LmiProBuyFormData) => lmiproCheckoutActions.calculatePrice(values),
    setTaxType: (type: string) => lmiproCheckoutActions.setTaxType(type),
    setStatesOptional: (optional: boolean) => lmiproBuyFormActions.setStatesOptional(optional),
}
export type LmiProBillingFormInfoActionsType = typeof mapLmiProBillingFormInfoActions
